// ======================================================================
// File Name       : ContentVideoNewEditContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
// import AWS from 'aws-sdk';
import $ from 'jquery';
import { Button, Col, Form, Table } from 'react-bootstrap';
import {
  contentVideoEdit, getVideoList, recieveCancelUpload, updateVideoProgress
} from '../../actions/content/ContentVideoAction';
import ContentVideoConfirmDialog from '../../components/content/ContentVideoConfirmDialog';
import FileUpload from '../../components/FileUpload';
import FormControlValidate from '../../components/FormControlValidate';
import Header from '../../components/Header';
import InformationDialog from '../../components/InformationDialog';
import MessageValidate from '../../components/MessageValidate';
import InformationModal from '../../components/modal/InformationModal';
import SelectBox from '../../components/SelectBox';
import UploadProgressBar from '../../components/UploadProgressBar';
import {
  DEFAULT_VIDEO_TYPE, MODE, SELECT_TARGET_DATA, VALIDATE_TYPE, VIDEO_TYPE
} from '../../constants/index';
import {
  MSG_ADD_VIDEO_SAME_TIME,
  MSG_EXCEED_VIDEO_PLAY_TIME, MSG_UPLOAD_FAIL, MSG_UPLOAD_SUCCESS
} from '../../constants/MessageTemplate';
import { CONTENT_VIDEO_LIST } from '../../constants/PathConstants';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { convertNumberToTimeFormat } from '../../utils/index';
import { VIDEO_REPLACEMENT_FLAG, VIDEO_STATUS } from '../../constants/ContentConstant';
import * as Path from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';

class ContentVideoNewEditContainer extends Component {
  constructor() {
    super();
    this.state = {
      mode: null,
      contentSecernId: '',
      contentName: '',
      video: {},
      videoChapter: {},
      videoSecond: null,
      videoChapterList: [],
      time: {
        hour: 0,
        minute: 0,
        second: 0,
      },
      uploadFile: null,
      uploadFileName: '',
      uploadFileSize: 0,
      exceedMaxLimit: false,
      showDialogConfirm: false,
      errorMessage: '',
      showLoading: false,
      videoReplacementFlag: VIDEO_REPLACEMENT_FLAG.NO_UPDATE,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeVideoChapter = this.handleChangeVideoChapter.bind(this);
    this.onAddBtnClick = this.onAddBtnClick.bind(this);
    this.onOKBtnClick = this.onOKBtnClick.bind(this);
    this.sentRequest = this.sentRequest.bind(this);
    this.hideDialog = this.hideDialog.bind(this);
    this.onCancelBtnClick = this.onCancelBtnClick.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.validateMaxTimeLimit = this.validateMaxTimeLimit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCancelUpload = this.handleCancelUpload.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id !== null && match.params.id !== undefined) {
      this.getContentList(match.params.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { content, match } = nextProps;
    const video = { ...this.state.video};
    if(!video || video.contentSecernId !== match.params.id) {
      const { videoInfo } = content;
      const contentVideoDetail = $.grep(
        videoInfo.contentList,
        e => e.contentSecernId === match.params.id,
      );
      if (contentVideoDetail.length > 0) {
        this.setState({
          video: contentVideoDetail[0],
        });
      }
    }
  }

  /**
     * Get content list
     *
     * @param {integer} selectTargetData
     */
  getContentList(contentSecernId) {
    const param = {
      searchInfo: {
        contentSecernIdList: [contentSecernId],
      },
      selectTargetData: SELECT_TARGET_DATA.DATA,
    };

    this.props.dispatch(getVideoList(param));
  }

  /**
     * handle change for user input
     * @param {*} event
     */
  handleChange(event) {
    const { name, value } = event.target;
    const video = { ...this.state.video, ...{ [name]: value } };
    this.setState({ video });
  }

  handleChangeVideoChapter(event) {
    const { name, value } = event.target;
    const videoChapter = this.state.videoChapter;
    if (name !== 'videoChapterName') {
      const time = { ...this.state.time, ...{ [name]: value } };
      this.setState({ time }, () => {
        this.converTimeFormatToSecond();
      });
    } else {
      videoChapter[name] = value;
      this.setState({ videoChapter });
    }
  }

  handleFileChange(event) {
    if (event.target.files.length !== 0) {
      const uploadFileName = event.target.files[0].name;
      const uploadFileSize = event.target.files[0].size;
      this.setState({
        uploadFile: event.target.files[0],
        uploadFileName,
        uploadFileSize,
      });
      // Step 7.0 No.4 START
      const { match } = this.props;
      if (match.params.id) { // edit mode
        const video = this.state.video;
        if (video) {
          video.videoStatus = VIDEO_STATUS.NEW,
          video.videoPlayTime = null;
          video.videoThumbnailInfo = null;
          video.videoChapterList = [];
          this.setState({ video });
        }
      }
      // Step 7.0 No.4 END
    }
  }

  converTimeFormatToSecond() {
    const hour = parseInt(this.state.time.hour, 10);
    const minute = parseInt(this.state.time.minute, 10);
    const second = parseInt(this.state.time.second, 10);
    const videoChapterPos = (hour * 3600) + (minute * 60) + second;
    const videoChapter = this.state.videoChapter;
    videoChapter.videoChapterPos = videoChapterPos;
    this.setState({ videoChapter });
  }

  onAddBtnClick() {
    if (this.validationAdd()) {
      if (this.state.videoChapter.videoChapterName) {
        const { video } = this.state;
        if (this.validateMaxTimeLimit(video)) {
          const chapterToAdd = { ...this.state.videoChapter };
          if (chapterToAdd && !chapterToAdd.videoChapterPos) {
            chapterToAdd.videoChapterPos = 0;
          }
          video.videoChapterList.push(chapterToAdd);
          video.videoChapterList.sort((a, b) => {
            if (isNaN(parseInt(a.videoChapterPos, 0)) || isNaN(parseInt(b.videoChapterPos, 0))) {
              return 0;
            }
            if (a.videoChapterPos > b.videoChapterPos) {
              return 1;
            } else if (a.videoChapterPos < b.videoChapterPos) {
              return -1;
            }
            return 0;
          });
          this.setState({
            ...this.state,
            video,
            exceedMaxLimit: false,
            errorMessage: '',
          });
        }
      }
    }
  }

  validateMaxTimeLimit(video) {
    let validMaxTime = true;
    const videoChapter = this.state.videoChapter;
    let errorMessage = '';
    if (video) {
      const { videoPlayTime } = video;
      const videoPos =
        this.state.videoChapter && this.state.videoChapter.videoChapterPos
          ? this.state.videoChapter.videoChapterPos
          : 0;
      const length = video.videoChapterList.length;
      const videoChapterList = video.videoChapterList;

      if (videoPos > videoPlayTime) {
        validMaxTime = false;
        errorMessage = MSG_EXCEED_VIDEO_PLAY_TIME;
      }
      if (validMaxTime) {
        for (let i = 0; i < length; i++) {
          if (videoChapterList[i]) {
            if (videoPos === videoChapterList[i].videoChapterPos) {
              validMaxTime = false;
              errorMessage = MSG_ADD_VIDEO_SAME_TIME;
              break;
            }
          }
        }
      }
    }
    if (!validMaxTime) {
      this.setState(
        {
          ...this.state,
          exceedMaxLimit: true,
          errorMessage,
        });
    }
    return validMaxTime;
  }

  onRemoveVideoChapter(index) {
    const { video } = this.state;
    video.videoChapterList.splice(index, 1);
    this.setState({ video });
  }

  onOKBtnClick() {
    if (this.validation()) {
      const { match } = this.props;
      this.setState({ showDialogConfirm: true });
      // Step 7.0 #4 START
      const isCancelUpload = false;
      this.props.dispatch(recieveCancelUpload(isCancelUpload));
      // Step 7.0 #4 END
    }
  }

  sentRequest() {
    this.setState({ showDialogConfirm: false });
    const { match } = this.props;
    const { history } = this.props;
    const { uploadFile } = this.state;
    const param = {
      editType: match.params.id ? MODE.EDIT_MODE : MODE.NEW_MODE,
      contentSecernId: this.state.video.contentSecernId || null,
      contentName: this.state.video.contentName,
      videoChapterList: this.state.video.videoChapterList,
      contentExtension: uploadFile ? uploadFile.name.split('.').pop() : DEFAULT_VIDEO_TYPE,
      videoReplacementFlag:
        match.params.id && uploadFile ? VIDEO_REPLACEMENT_FLAG.UPDATE : VIDEO_REPLACEMENT_FLAG.NO_UPDATE,
    };
    this.props.dispatch(contentVideoEdit(param, history, uploadFile));
  }

  hideDialog() {
    this.setState({ showDialogConfirm: false });
  }

  validation() {
    return (
      Object.keys(this.refsToValidate).every(
        ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
      )
    );
  }

  validationAdd() {
    return (
      Object.keys(this.refsToValidateAdd).every(
        ref => this.refsToValidateAdd[ref].validation && this.refsToValidateAdd[ref].validation(),
      )
    );
  }

  onCancelBtnClick() {
    const { history } = this.props;
    history.goBack();
  }

  handleClose() {
    const { history } = this.props;
    const param = {
      showProgressBar: false,
      showSuccessfulModal: false,
      percentage: 0,
      showReasonModal: false,
      reason: '',
    };
    this.props.dispatch(updateVideoProgress(param));
    history.push(CONTENT_VIDEO_LIST);
  }
  // #6310
  handleCancelUpload() {
    const { handleCancelled } = this.props.videoProgress;
    const isCancelUpload = true;
    this.props.dispatch(recieveCancelUpload(isCancelUpload));
    handleCancelled();
  }
  render() {
    const { match } = this.props;
    this.refsToValidate = [];
    this.refsToValidateAdd = [];
    const isEditMode = !!match.params.id;
    let videoChapterList = null;
    const videoPlayTime = convertNumberToTimeFormat(this.state.video.videoPlayTime);
    const acceptTypes = VIDEO_TYPE.map(type => `.${type}`).join(',');
    const validates = !isEditMode ? [VALIDATE_TYPE.REQUIRED] : [];
    if (isEditMode && this.state.video.videoChapterList) {
      videoChapterList = this.state.video.videoChapterList.map((videoChapter, index) =>
        (<tr key={index}>
          <td>
            {videoChapter.videoChapterName}
          </td>
          <td>
            {convertNumberToTimeFormat(videoChapter.videoChapterPos)}
          </td>
          <td>
            <i className="bi bi-trash" onClick={this.onRemoveVideoChapter.bind(this, index)} />
          </td>
        </tr>),
      );
    }
    const { video } = this.state;
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.CONTENT_VIDEO_LIST}
          text="ビデオ一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name={isEditMode ? "ビデオの編集" : "ビデオの追加"} />
        {isEditMode ? (
          <h3>編集する項目を指定してください</h3>
        ) : (
          <h3>登録する項目を指定してください</h3>
        )}
        <Form className="form-horizontal padding-top-10">
          {isEditMode && (
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                コンテンツ識別ID
              </Col>
              <Col as={Form.Label} sm={6} className="padding-left-clear">
                {video.contentSecernId || ""}
              </Col>
            </Form.Group>
          )}
          {!isEditMode && (
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                コンテンツ識別ID
              </Col>
              <Col sm={6}>
                <FormControlValidate
                  type="text"
                  name="contentSecernId"
                  maxLength="64"
                  disabled={isEditMode}
                  value={video.contentSecernId || ""}
                  onChange={this.handleChange}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  validateType={VALIDATE_TYPE.ID}
                  label="コンテンツ識別ID"
                />
              </Col>
            </Form.Group>
          )}
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={4}>
              コンテンツ名 <span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={6}>
              <FormControlValidate
                label="コンテンツ名"
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                required
                name="contentName"
                onChange={this.handleChange}
                type="text"
                maxLength="256"
                value={video.contentName || ""}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info flex-wrap">
            <Col as={Form.Label} sm={4}>
              ファイル選択
              <span className="required">{!isEditMode && <>&nbsp;(※)</>}</span>
            </Col>
            <Col sm={6}>
              <FormControlValidate
                label="ファイル選択"
                type="text"
                name="file_upload"
                className="margin-bottom-10"
                value={this.state.uploadFileName || this.props.fileName || ""}
                required={!isEditMode}
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                fileSize={this.state.uploadFileSize}
                validateType={VALIDATE_TYPE.VIDEO_SIZE}
              />
            </Col>
            <FileUpload
              labelName="ファイル選択"
              onChange={this.handleFileChange}
              fileName={this.state.uploadFileName}
              accept={acceptTypes}
            />
            {!this.state.uploadFileName && (
              <Col
                as={Form.Label}
                sm={{
                  span: 7,
                  offset: 4,
                }}
              >
                <FormControlValidate
                  label="ファイル選択"
                  validateType={VALIDATE_TYPE.LABEL}
                  value={this.state.uploadFileName || ""}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  required={!isEditMode}
                />
              </Col>
            )}
            <Col as={Form.Label} sm={12}>
              ※アップロードするファイルサイズの上限は10GBまでとなります。
              {/* #6739 */}
              <p className="padding-top-5">
                ※動画の長さは3時間未満を推奨としております。
              </p>{" "}
              {/* step11.2.0 TAS-16636 */}
              <p className="padding-top-5">
                ※アップロード後の動画はダウンロード不可です。
              </p>{" "}
              {/* step11.2.0 TAS-16636 */}
            </Col>
          </Form.Group>
          {isEditMode && (
            <Col>
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={2}>
                  チャプター
                </Col>
                <Col
                  as={Form.Label}
                  sm={{
                    span: 1,
                    offset: 1,
                  }}
                >
                  名称
                </Col>
                <Col sm={6}>
                  <FormControlValidate
                    label="名称"
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidateAdd.push(ref);
                      }
                    }}
                    required
                    type="text"
                    name="videoChapterName"
                    value={this.state.videoChapter.videoChapterName || ""}
                    onChange={this.handleChangeVideoChapter}
                  />
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col
                  as={Form.Label}
                  sm={{
                    span: 1,
                    offset: 3,
                  }}
                >
                  時間
                </Col>
                <Col sm={2} className="padding-left-clear">
                  <SelectBox
                    data={SELECT_BOX_DATA.HOUR}
                    name="hour"
                    value={parseInt(this.state.time.hour, 10)}
                    onChange={this.handleChangeVideoChapter}
                  />
                </Col>
                <Col sm={2} className="padding-left-15">
                  <SelectBox
                    data={SELECT_BOX_DATA.MINUTE_SECOND}
                    name="minute"
                    value={this.state.time.minute}
                    onChange={this.handleChangeVideoChapter}
                  />
                </Col>
                <Col sm={2} className="padding-left-15">
                  <SelectBox
                    data={SELECT_BOX_DATA.MINUTE_SECOND}
                    name="second"
                    value={this.state.time.second}
                    onChange={this.handleChangeVideoChapter}
                  />
                </Col>
                <Col sm={1} className="padding-left-15">
                  <Button
                    variant="primary"
                    className="btn-96"
                    onClick={this.onAddBtnClick}
                  >
                    追加
                  </Button>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col
                  as={Form.Label}
                  sm={{
                    span: 2,
                    offset: 4,
                  }}
                  className="padding-left-clear"
                >
                  再生時間
                </Col>
                <Col as={Form.Label} sm={2}>
                  {videoPlayTime}
                </Col>
              </Form.Group>
              {this.state.exceedMaxLimit && (
                <Col sm={12} style={{ marginBottom: "5px" }} as={Form.Label}>
                  <MessageValidate
                    errorType={1}
                    visible={this.state.exceedMaxLimit}
                    errorMessage={this.state.errorMessage}
                  />
                </Col>
              )}
              <Table striped hover>
                <thead>
                  <tr>
                    <th>チャプター名</th>
                    <th>再生時間</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>{videoChapterList}</tbody>
              </Table>
            </Col>
          )}
          {isEditMode ? (
            <Form.Group className="margin-top-20 text-center">
              <Col sm={12} className="text-center">
                <Button 
                  variant="default"
                  className="btn btn-default btn-96 margin-10"
                  onClick={this.onCancelBtnClick}
                >
                  キャンセル
                </Button>
                <Button
                  variant="primary"
                  className="btn-96 margin-10"
                  onClick={this.onOKBtnClick}
                >
                  OK
                </Button>
              </Col>
            </Form.Group>
          ) : (
            <Form.Group className="margin-top-20 text-center">
              <Col sm={12} className="text-center">
                <Button
                  variant="primary"
                  className="btn-96"
                  onClick={this.onOKBtnClick}
                >
                  OK
                </Button>
              </Col>
            </Form.Group>
          )}
        </Form>
        <ContentVideoConfirmDialog
          showModal={this.state.showDialogConfirm}
          handleOkClick={this.sentRequest}
          handleCancelClick={this.hideDialog}
          videoData={video}
          isRegisterMode={!isEditMode}
          uploadFile={this.state.uploadFile} // Step 7.0 No.4
        />
        <UploadProgressBar
          showModal={this.props.videoProgress.showProgressBar}
          percentage={this.props.videoProgress.percentage}
          onCancel={this.handleCancelUpload}
        />
        {/* show message incase of uploading successfully */}
        <InformationDialog
          showModal={this.props.videoProgress.showSuccessfulModal}
          onOK={this.handleClose}
          content={MSG_UPLOAD_SUCCESS}
        />
        {/* Reason of error upload */}
        <InformationModal
          showModal={this.props.videoProgress.showReasonModal}
          // showModal
          onOK={this.handleClose}
          content={MSG_UPLOAD_FAIL}
          value={this.props.videoProgress.reason}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({ ...{
  content: state.content,
  authed: state.authed,
  videoProgress: state.content.videoProgress,
} });

export default connect(mapStateToProps)(ContentVideoNewEditContainer);
